document.addEventListener('turbo:load', function(e) {
  if (!document.querySelector('[data-page="landing"]')) return;

  /* --------------------------------------------------
                Hero Animation
  -------------------------------------------------- */
  const pagesLandingIndexHeroAnimation = function() {
    const heroHeadline = document.querySelector('[data-gsap="hero-headline"]');
    const heroHeadlineText = heroHeadline.textContent.trim();
    const tl = gsap.timeline();

    heroHeadline.textContent = '';
    heroHeadlineText.split('').forEach(char => {
      const span = document.createElement('span');
      span.textContent = char;
      heroHeadline.appendChild(span);
    });

    tl.from(heroHeadline.children, {
      opacity: 0,
      duration: 0.01,
      stagger: 0.01,
      ease: "none"
    });
  }

  /* --------------------------------------------------
                Architects Headline Animation
  -------------------------------------------------- */
  const pagesLandingIndexArchitectsHeadlineAnimation = function() {
    const architectsHeadline = document.querySelector('[data-gsap="architects-headline"]');
    const architectsHeadlineText = architectsHeadline.textContent.trim();
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: architectsHeadline,
        start: "top bottom-=100",
        toggleActions: "play none none reverse"
      }
    });

    architectsHeadline.textContent = '';
    architectsHeadlineText.split('').forEach(char => {
      const span = document.createElement('span');
      span.textContent = char;
      architectsHeadline.appendChild(span);
    });

    tl.from(architectsHeadline.children, {
      opacity: 0,
      duration: 0.02,
      stagger: 0.02,
      ease: "none"
    });
  }
  
  /* --------------------------------------------------
                Review Animation
  -------------------------------------------------- */
  const pagesLandingIndexReviewAnimation = function() {
    const reviewElements = document.querySelectorAll('[data-gsap="review"]');
    const reviewsTl = gsap.timeline({
      scrollTrigger: {
        trigger: reviewElements[0]?.parentElement || reviewElements[0],
        start: "top bottom-=100",
        toggleActions: "play none none reverse"
      }
    });
    const totalAnimationTime = 1; 
    const staggerTime = totalAnimationTime / (reviewElements.length || 1);

    gsap.set(reviewElements, {
      opacity: 0,
      y: 50
    });

    reviewElements.forEach((element, index) => {
      reviewsTl.to(element, {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "power2.out"
      }, index * staggerTime);

      ScrollTrigger.create({
        trigger: element,
        start: "top bottom",
        end: "bottom top",
        scrub: 0.5,
        onUpdate: (self) => {
          const yPos = (self.progress * -30);
          gsap.set(element, { backgroundPositionY: yPos + "px" });
        }
      });
    });
  }

  /* --------------------------------------------------
                Footer Headline Animation
  -------------------------------------------------- */
  const pagesLandingIndexFooterHeadlineAnimation = function() {
    const footerHeadline = document.querySelector('[data-gsap="footer-headline"]');
    const footerHeadlineText = footerHeadline.textContent.trim();
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: footerHeadline,
        start: "top bottom-=100",
        toggleActions: "play none none reverse"
      }
    });

    footerHeadline.textContent = '';
    footerHeadlineText.split('').forEach(char => {
      const span = document.createElement('span');
      span.textContent = char;
      footerHeadline.appendChild(span);
    });

    tl.from(footerHeadline.children, {
      opacity: 0,
      duration: 0.05,
      stagger: 0.05,
      ease: "none"
    });
  }

  /* --------------------------------------------------
                Footer Smooth Scroll
  -------------------------------------------------- */
  const pagesLandingIndexFooterSmoothScroll = function() {
    const getAccessButtons = document.querySelectorAll('a[href="#lead-form-container"]');

    getAccessButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const footer = document.querySelector('footer');
        if (footer) {
          footer.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  /* --------------------------------------------------
                Video Modal
  -------------------------------------------------- */
  const pagesLandingIndexVideoModal = function() {
    const videoTrigger = document.querySelector('[data-video-trigger]');
    const videoModal = document.getElementById('video-modal');
    const videoEmbed = document.getElementById('video-embed');
    const videoModalClose = document.getElementById('video-modal-close');
    const sampleVideoUrl = 'https://storage.googleapis.com/biddyhq/demo.mp4';
    
    if (videoTrigger && videoModal && videoEmbed) {
      videoTrigger.addEventListener('click', () => {
        videoEmbed.src = sampleVideoUrl;
        videoModal.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
      });
      
      const closeModal = () => {
        videoModal.classList.add('hidden');
        videoEmbed.pause();
        videoEmbed.currentTime = 0;
        videoEmbed.src = '';
        document.body.style.overflow = '';
      };
      
      if (videoModalClose) {
        videoModalClose.addEventListener('click', closeModal);
      }
      
      videoModal.addEventListener('click', (e) => {
        if (e.target === videoModal) {
          closeModal();
        }
      });
    }
  }

  /* --------------------------------------------------
                Functions
  -------------------------------------------------- */
  pagesLandingIndexHeroAnimation();
  pagesLandingIndexArchitectsHeadlineAnimation();
  pagesLandingIndexReviewAnimation();
  pagesLandingIndexFooterHeadlineAnimation();
  pagesLandingIndexFooterSmoothScroll();
  pagesLandingIndexVideoModal();
});
